<template>
  <div class="tva-slider-container">
    <TvaSlider :config="config">
      <template v-if="config.componentType === 'simple'">
        <div
          class="tva-slider-content"
          v-for="(element, elIndex) in content"
          :key="elIndex"
        >
          <img
            class="tva-slider-content-image"
            v-if="element.image"
            :style="{ width: '100%' }"
            :data-flickity-lazyload="`${baseUrl}${element.image}`"
          />
          <div
            class="tva-slider-content-text"
            v-if="element.text"
            v-html="element.text"
          ></div>
        </div>
      </template>
      <template v-if="config.componentType === 'component'">
        <component
          class="tva-slide-component"
          v-for="(element, elIndex) in content"
          :key="elIndex"
          v-bind:is="element.componentName"
          :config="element.config"
          :content="element.content"
        ></component>
      </template>
    </TvaSlider>
  </div>
</template>
<script>
import TvaSlider from "@/utilities/TvaSlider.vue";
import TvaCard from "@/components/TvaCard.vue";
export default {
  props: ["content", "config"],
  data() {
    return {
      baseUrl: process.env.BASE_URL
    };
  },
  components: {
    TvaSlider,
    TvaCard
  }
};
</script>
<style lang="scss" scoped>
// GLOBAL STYLE
</style>
